import { Theme } from '@mui/material';


const ToggleButton = (theme: Theme) => {
  return {
  };
};

export default ToggleButton;
